<button
  [disabled]="disabled"
  [type]="buttonType"
  (click)="handleClickEvent()"
  [ngClass]="class"
  [attr.aria-label]="ariaLabel"
  data-cy="button"
>
  <ng-content />
</button>
